$(document).ready(function(){
    //vrProductsBottom = new VrProductsBottom();
    var vrHeader = new VrHeader(),
        vrEvents = new VrEvents(),
        vrRelatedCatalog = new VrRelatedCatalog(),
        //vrRelailersBottom = new VrRelailersBottom(),
        vrHeaderCategories = new VrHeaderCategories(),
        vrScrollDownBtn = new VrScrollDownBtn();
        //vrPromotionsBottom = new VrPromotionsBottom();
});